export default __webpack_public_path__ + "static/media/grafema_packaging-cale-do-oiro_01.902c0f5f.jpg";